import styles from './TradingHistoryRevamp.module.css';
import { useGetApplicationQuery } from '../../../api/lendingApi/lendingApiQueries';
import { useNumberFormat } from '../../../hooks/useNumberFormat';
import { useOffersUK } from '../../../hooks/useOffers/useOffersUK';
import { TradingHistoryLoader } from '../TradingHistoryLoader';

const TradingHistoryRevamp = () => {
  const { formatCurrency } = useNumberFormat();

  const { application } = useGetApplicationQuery();

  const { isLoadingOffers, offers } = useOffersUK({
    enabled: true,
  });

  const suggestedOffer = offers?.find((offer) => offer.is_suggested);
  const estimatedAmount = suggestedOffer?.max_amount;
  const requestedAmount = application?.requested_products?.[0]?.amount;

  const displayAmount = estimatedAmount ?? requestedAmount;

  if (isLoadingOffers) {
    return <TradingHistoryLoader />;
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>
        You’re eligible for up to{' '}
        <span className={styles.amount}>{formatCurrency(displayAmount)}*</span>
      </h1>
      <p className={styles.subheading}>
        We just need a little bit more information to be able to make the most
        accurate assessment.
      </p>
    </div>
  );
};

export default TradingHistoryRevamp;
